var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-header clearfix", style: _vm.headerStyle },
    [
      _c("div", { staticClass: "page-header-wrap" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "header-rt fl-r" }, [
          _c("ul", { staticClass: "nav-list clearfix" }, [
            !_vm.userName
              ? _c("li", { staticClass: "nav-item fl-r" }, [
                  _c("a", { attrs: { href: _vm.regiesterUrl } }, [
                    _vm._v(_vm._s(_vm.getConstants("REGISTER")))
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.userName
              ? _c(
                  "li",
                  { staticClass: "nav-item fl-r" },
                  [
                    _vm.loginShow
                      ? _c("login-modal", {
                          staticClass: "login-modal",
                          on: {
                            hideModal: function($event) {
                              _vm.loginShow = false
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c("a", { attrs: { href: _vm.loginUrl } }, [
                      _vm._v(_vm._s(_vm.getConstants("LOGIN")))
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.userName
              ? _c("li", { staticClass: "nav-item user-name fl-r" }, [
                  _c("span", { domProps: { innerHTML: _vm._s(_vm.userName) } })
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item fl-r" }, [
              _c("a", { attrs: { href: "/s/contactus" } }, [
                _vm._v(_vm._s(_vm.getConstants("CONTACT_US")))
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item fl-r" }, [
              _c("a", { attrs: { href: "/s/enterprise" } }, [
                _vm._v(_vm._s(_vm.getConstants("ENTERPRISE_EDITION_FOR_SHORT")))
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item fl-r" }, [
              _c("a", { attrs: { href: "/s/team" } }, [
                _vm._v(_vm._s(_vm.getConstants("TEAM_EDITION_FOR_SHORT")))
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item fl-r" }, [
              _c("a", { attrs: { href: "/s/pricing" } }, [
                _vm._v(_vm._s(_vm.getConstants("INDIVIDUAL_EDITION_FOR_SHORT")))
              ])
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "nav-item fl-r" }, [
              _c("a", { attrs: { href: "/" } }, [
                _vm._v(_vm._s(_vm.getConstants("HOMEPAGE")))
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-lf fl-l" }, [
      _c("img", {
        staticClass: "logo",
        attrs: { src: "/static/images/welcome-page/welcome-logo.png", alt: "" }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }